import { render, staticRenderFns } from "./ModernInfinityDimensionRow.vue?vue&type=template&id=6f5a0de3&scoped=true"
import script from "./ModernInfinityDimensionRow.vue?vue&type=script&lang=js"
export * from "./ModernInfinityDimensionRow.vue?vue&type=script&lang=js"
import style0 from "./ModernInfinityDimensionRow.vue?vue&type=style&index=0&id=6f5a0de3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a0de3",
  null
  
)

export default component.exports